import { Button, Card, CardContent } from '@mui/material'
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward'
import { getDocumentExpirationStatus } from '../../utils/documentExpiration'

const statusDetails = {
  expired: {
    label: 'Vencido',
    cardClassName: '!border-danger',
    textClassName: 'text-danger',
  },
  expiringSoon: {
    label: 'Próximo do vencimento',
    cardClassName: '!border-warning',
    textClassName: 'text-warning',
  },
}

const formatDate = (date) => {
  if (!date) return 'Não informada'

  const [year, month, day] = date.split('-')
  if (!year || !month || !day) return 'Data inválida'

  return `${day}/${month}/${year}`
}

const ExpiredDocumentsList = ({ documents, onAccessDocument }) => {
  return (
    <div className="flex flex-col gap-2 mt-2">
      {documents.map((document) => {
        const status = getDocumentExpirationStatus(document.expirationDate)
        const details = statusDetails[status]

        return (
          <Card
            key={document.id}
            variant="outlined"
            data-testid={`document-${document.id}`}
            data-status={status || undefined}
            className={details?.cardClassName || ''}
          >
            <CardContent>
              <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
                <h2 className="font-semibold text-base">{document.name}</h2>
                {details && (
                  <span
                    className={`text-sm font-semibold ${details.textClassName}`}
                  >
                    {details.label}
                  </span>
                )}
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                <div>
                  <p className="text-xs opacity-70">Data de emissão</p>
                  <p className="font-medium">
                    {formatDate(document.issueDate)}
                  </p>
                </div>
                <div>
                  <p className="text-xs opacity-70">Data de vencimento</p>
                  <p
                    className={`font-medium ${details?.textClassName || ''}`}
                  >
                    {formatDate(document.expirationDate)}
                  </p>
                </div>
                {(document.type === 'cr' ||
                  (document.type === 'weaponDocument' &&
                    document.pessoaArmaID)) && (
                    <Button
                      fullWidth
                      type="button"
                      variant="contained"
                      onClick={() => onAccessDocument(document)}
                      startIcon={<ArrowOutwardIcon />}
                    >
                      Acessar Documento
                    </Button>
                  )}
              </div>
            </CardContent>
          </Card>
        )
      })}
    </div>
  )
}

export default ExpiredDocumentsList
